<div>
    <form [formGroup]="form" (ngSubmit)="submitForm(model, form)"
    autocomplete="off" ngNativeValidate novalidate>
        <formly-form [form]="form" [fields]="fields" 
        [model]="formModel" [options]="options" 
        ngNativeValidate>
            <div class="btn-cont {{btnContClass}} mb-3 pt-12"
            *ngIf="!multiStep && !noAction">
                <button mat-raised-button
                (click)="cancelForm()"
                *ngIf="cancelBtn">
                    CANCEL
                </button>
                <button mat-raised-button
                class="{{btnClass || 'w-100-p'}} mt-10"
                color="success" type="submit"
                [class.spinner]="submitted"
                [disabled]="submitted && form.valid">
                    {{ btnTxt || 'Save' | uppercase}}
                </button>
                <button mat-raised-button
                (click)="cancelForm()"
                *ngIf="baseCancel">
                    CANCEL
                </button>
            </div>
            <div class="btn-cont {{btnContClass}} mb-3 pt-12 w-100-p
            d-flex justify-content-between"
            *ngIf="multiStep">
                <button mat-raised-button
                class="float-left"
                (click)="back()" type="button"
                *ngIf="multiStep.back">
                    {{ cancelTxt }}
                </button>
                <button mat-raised-button
                class="{{btnClass || 'w-100-p'}} mt-10 float-right mr-0"
                color="accent" type="submit"
                [class.spinner]="submitted"
                [disabled]="submitted && form.valid">
                    {{ btnTxt || 'Save' | uppercase}}&nbsp;
                    <mat-icon class="btn-icon">keyboard_arrow_right</mat-icon>
                    <mat-icon class="btn-icon">keyboard_arrow_right</mat-icon>
                </button>
            </div>
        </formly-form>
    </form>
</div>